module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Code-d786ec1b446a9011af5eba12b2ad7168.svg";